export const capSpace = (str) =>
  str
    .replace(/[\s+-]/g, "-")
    .replace(/[^\w-]/g, "")
    .toLowerCase();
